export type SimulationWidgetViewState = "idle" | "submitting" | "success" | "error";

export const SIMULATION_FORM_STEPS = [
  "intro",
  "statut",
  "bien",
  "financement",
  "contact",
  "result",
  "expert-optin",
] as const;
export type SimulationFormStep = (typeof SIMULATION_FORM_STEPS)[number];

export interface SimulationResultModel {
  rendementBrut: number;
  rendementNet: number;
  moyenneCashFlow: number;
  triMax: number;
  triAnnee: number;
  triDixAns: number;
}

export interface SimulationFormModel {
  slugParameter: "resident" | "non-resident";
  email: string;
  firstName: string;
  source: string;
  consent: boolean;
  prixAchat: string;
  loyerAnnuel: string;
  apport: string;
  dureePret: string;
  taux: string;
  expertComptable: boolean;
  courtier: boolean;
  chasseurImmobilier: boolean;
  honeypot: string;
}

export function getInitialSimulationFormStep(): SimulationFormStep {
  return SIMULATION_FORM_STEPS[0];
}

export function getNextSimulationFormStep(
  currentStep: SimulationFormStep,
): SimulationFormStep {
  switch (currentStep) {
    case "intro":
      return "statut";
    case "statut":
      return "bien";
    case "bien":
      return "financement";
    case "financement":
      return "contact";
    case "contact":
      return "result";
    case "result":
      return "expert-optin";
    case "expert-optin":
      return "expert-optin";
    default:
      return currentStep;
  }
}

export function getPreviousSimulationFormStep(
  currentStep: SimulationFormStep,
): SimulationFormStep {
  switch (currentStep) {
    case "statut":
      return "intro";
    case "bien":
      return "statut";
    case "financement":
      return "bien";
    case "contact":
      return "financement";
    case "result":
      return "contact";
    case "expert-optin":
      return "result";
    default:
      return currentStep;
  }
}

export function getSimulationFormProgress(
  currentStep: SimulationFormStep,
): { current: number; total: number } {
  switch (currentStep) {
    case "intro":
      return { current: 0, total: 5 };
    case "statut":
      return { current: 1, total: 5 };
    case "bien":
      return { current: 2, total: 5 };
    case "financement":
      return { current: 3, total: 5 };
    case "contact":
      return { current: 4, total: 5 };
    case "result":
      return { current: 5, total: 5 };
    case "expert-optin":
      return { current: 5, total: 5 };
    default:
      return { current: 0, total: 5 };
  }
}
